interface BannerData {
  DesktopBannerHeight?: number;
  MobileBannerHeight?: number;
}

export const allProgram: BannerData = {
  DesktopBannerHeight: 550,
  MobileBannerHeight: 280,
};
export const aboutBanner: BannerData = {
  DesktopBannerHeight: 480,
  MobileBannerHeight: 228,
};

export const accreditationBanner: BannerData = {
  DesktopBannerHeight: 380,
  MobileBannerHeight: 288,
};

export const LeadershipBanner: BannerData = {
  DesktopBannerHeight: 448,
  MobileBannerHeight: 228,
};

export const SchoolPageData: BannerData = {
  DesktopBannerHeight: 480,
  MobileBannerHeight: 272,
};
export const PrivacyPolicyData: BannerData = {
  DesktopBannerHeight: 480,
  MobileBannerHeight: 272,
};
export const AlumniPageData: BannerData = {
  DesktopBannerHeight: 480,
  MobileBannerHeight: 272,
};
export const SucessStoryPageData: BannerData = {
  DesktopBannerHeight: 480,
  MobileBannerHeight: 272,
};
export const FacultyBanner: BannerData = {
  DesktopBannerHeight: 480,
  MobileBannerHeight: 272,
};
export const CareerBanner: BannerData = {
  DesktopBannerHeight: 440,
  MobileBannerHeight: 280,
};
